import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=5aa6d875&scoped=true&"
import script from "./Press.vue?vue&type=script&lang=js&"
export * from "./Press.vue?vue&type=script&lang=js&"
import style0 from "./Press.vue?vue&type=style&index=0&id=5aa6d875&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa6d875",
  null
  
)

component.options.__file = "Press.vue"
export default component.exports